import React, { useState, useRef, lazy, Suspense } from "react";
import { alert_error, alert_success } from "../AppContext.js";
import QRCode from "qrcode.react";
import axios from 'axios';
import { Cookies } from '../index.js';
import { useParams, useNavigate } from 'react-router-dom';
import AdModal from '../app_structure/AdModal_deposit.jsx';
import Bannerprofile from '../shop/ads/Bannerprofile.jsx';
const LazyReCAPTCHA = lazy(() => import("../app_structure/LazyReCAPTCHA"));
function Momoidcode() {
  const navigate = useNavigate();
  function switch_router(link) {
    navigate(link);
  };
  const [success, setsuccess] = useState(false);
  const [nutxuly, setnutxuly] = useState(0);
  const [info, setInfo] = useState("ok");
  const [site_sdt_momo, setSiteSdtMomo] = useState("0928889798");
  const [site_ten_momo, setSiteTenMomo] = useState("Nguyễn Đăng Tín");
  const [showcaptcha, setshowcaptcha] = useState(false);
  const [nutorder, setnutorder] = useState('Vô app momo chuyển cho tớ là Coins lên liền nhé =D');
  const [macode, setmacode] = useState('Vô app momo chuyển cho tớ là Coins lên liền nhé =D');
  const qrCodeStyle = {
    backgroundColor: "#ff69b4",
  };
  const [isDivVisible, setIsDivVisible] = useState(true);
  const recaptchaRef = React.createRef();
  function copyText(value) {
    alert_success("Đã sao chép");
    window.saochepnative(value);
  }
  const handleToggle = () => {
    setIsDivVisible(!isDivVisible);
  };
  const inputRef = useRef(null);
  const handleRecaptchaChange = (value) => {
    console.log(value);
    const maxLength = 200;

    if (value.length > maxLength) {
      setnutxuly(1);
      setnutorder('Bạn hãy đợi vài giây để app xử lý nhé');
      const myCookieValue = Cookies.get('apikey');
      let data = JSON.stringify({
        "recaptchaValue": value,
        "macode": macode,
        "apikey": myCookieValue
      });
      let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: 'https://hust.media/api/wallet/deposit_momo_code.php',
        headers: {
          'Content-Type': 'application/json'
        },
        data: data
      };
      axios.post(config.url, config.data, config.headers)
        .then((response) => {
          setnutxuly(0);
          testFunction(response);
        })
        .catch((error) => {
          setnutxuly(0);
          alert_error(error);
        });
    }
    else {
      setnutorder('Đã xảy ra lỗi tải lại trang nhé');
    }
  };
  function testFunction(response) {
    const info = response.data;
    const status = info.status;
    const message = info.message;
    setnutxuly(0);

    if (status == 1) {
      alert_success(message);
      setnutorder('Cảm ơn bạn đã ủng hộ');
      setTimeout(() => {
        setsuccess(true);
      }, 700);
    }
    else if (status == 0) {
      setnutorder(message);
      alert_error(message);
    }
    else {
      setnutorder('Đã xảy ra lỗi vui lòng nhập lại');
      alert_error('Đã xảy ra lỗi vui lòng nhập lại');
    }
    if (info.redirect != null && info.redirect != '') {
      setTimeout(function () {
        // Chuyển hướng sang trang web khác
        window.location.href = info.redirect;
      }, 1700);
    }
  };
  const handleClick = () => {
    if (inputRef.current) {

      const inputValue = inputRef.current.value;
      if (inputValue) {
        inputRef.current.disabled = true;
        setshowcaptcha(true);
        setnutorder('Hãy tích vào ô tôi không phải người máy')
        console.log("Giá trị đã nhập:", inputValue);
        setmacode(inputValue);
      }
      else {
        alert_error('Chưa nhập gì');
      }
    }
  };
  const [showAd, setShowAd] = useState(true);
  const handleCloseAd = () => {
    setShowAd(false);
    // switch_router('/reactapp/');
  };
  return (
    <div className="container-fluid mt-7">
      {
        success &&
        (<>
          <AdModal isOpen={showAd} onClose={handleCloseAd} switch_router={switch_router} className="mx-auto" />
        </>)
      }
      <div className="row">
        <div className="col-xl-7 mb-5 mb-xl-0">
          <div className="card card-profile shadow">
            <div className="card-header border-0">
              <div className="row align-items-center">
                {info == null ? (
                  <div className="container-fluid">
                    <div className="row" style={{ backgroundColor: "#FFB6C1" }}>
                      <p className="text-center" style={{ color: "#fff" }}>
                        <div
                          className="text-center spinner-border"
                          role="status"
                        ></div>
                        <br />
                        Đang tải dữ liệu
                      </p>
                    </div>
                  </div>
                ) : (
                  <div className="col">
                    <h3 className="text-lg text-muted font-medium mb-0">
                      Thông Tin ví MOMO
                    </h3>
                    <ul className="pl-4 mt-2 space-y-3">
                      <li className="flex items-center">
                        <span className="mr-1 text-pink-500 font-medium">
                          Số Điện Thoại:
                        </span>
                        <input
                          type="text"
                          className="form-control border-pink-600"
                          value={site_sdt_momo}
                          id="input1"
                          readOnly
                        />
                        <button
                          onClick={() => copyText(site_sdt_momo)}
                          className="ml-2 group rounded-2xl h-15 w-48 bg-pink-300 font-bold text-lg text-white relative overflow-hidden"
                        >
                          <span className="text-base">
                            <b>Sao chép</b>
                          </span>
                          <div className="absolute duration-300 inset-0 w-full h-full transition-all scale-0 group-hover:scale-100 group-hover:bg-white/30 rounded-2xl"></div>
                        </button>
                      </li>
                      <li className="flex items-center">
                        <span className="mr-2 text-pink-500 font-medium">
                          Chủ Tài Khoản:
                        </span>
                        <span>
                          <b>{site_ten_momo}</b>
                        </span>
                      </li>
                      <li className="flex items-center">
                        <span className="mr-0 text-pink-500 font-medium">
                          mã giao dịch
                        </span>
                        <input
                          ref={inputRef}
                          className="mt-2 border-3 form-control-pink form-control form-control-alternative"
                          type="text"
                          placeholder="Nhập mã giao dịch"
                        />


                        {!showcaptcha ? (<button
                          onClick={handleClick}
                          className="ml-2 group rounded-2xl h-15 w-40 bg-pink-300 font-bold text-lg text-white relative overflow-hidden"
                        >
                          <span className="text-base">
                            <b>Xác nhận</b>
                          </span>

                          <div className="absolute duration-300 inset-0 w-full h-full transition-all scale-0 group-hover:scale-100 group-hover:bg-white/30 rounded-2xl"></div>
                        </button>) :
                          <button
                            onClick={() => window.location.reload(false)}
                            className="ml-2 group rounded-2xl h-15 w-48 bg-pink-300 font-bold text-lg text-white relative overflow-hidden"
                          >
                            <span className="text-base">
                              <b>Nhập lại</b>
                            </span>

                            <div className="absolute duration-300 inset-0 w-full h-full transition-all scale-0 group-hover:scale-100 group-hover:bg-white/30 rounded-2xl"></div>
                          </button>
                        }

                      </li>
                      {showcaptcha && (
                        <div style={{ textAlign: "center" }} className="mt-0  flex justify-center items-center ">
                          <Suspense fallback={<div>Loading...</div>}>
                            <LazyReCAPTCHA
                              recaptchaRef={recaptchaRef}
                              handleRecaptchaChange={handleRecaptchaChange}
                              sitekey='6LeB3qclAAAAAGkFcUEAgX8Lmi37Frx0m7UUImEN'
                            />
                          </Suspense>
                        </div>)}
                    </ul>
                    <li className="flex items-center mt-2">
                      <span className="mr-3 text-pink-500 font-medium">
                        Trạng thái:
                      </span>
                      <button className="group rounded-2xl h-12 w-55 bg-pink-300 font-bold text-base text-white relative overflow-hidden">
                        {nutxuly == 1 && (<span className="spinner-border spinner-border-sm"></span>)}
                        {nutorder}
                        <div className="absolute duration-300 inset-0 w-full h-full transition-all scale-0 group-hover:scale-100 group-hover:bg-white/30 rounded-2xl"></div>
                      </button>
                    </li>
                    <h3 className="text-lg text-muted font-medium mt-2">
                      HƯỚNG DẪN NẠP TIỀN
                    </h3>
                    <ol className="list-decimal list-inside pl-4">
                      <li className="text-sm mb-0">
                        Bước 1 : Chuyển tiền và có thể bỏ trống lời nhắn
                      </li>
                      <li className="text-sm mb-0">
                        Bước 2 : Nhập mã giao dịch rồi ấn xác nhận
                      </li>
                      <li className="text-sm font-normal">
                        Vì dùng phần mềm quét lịch sử momo nên bạn đợi vài giây
                        nhập mã là Hust Media cộng Coins cho nhé
                      </li>

                    </ol>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        <div className="col-xl-5">
          <div className="card card-profile shadow rounded-lg border-0">
            <div className="card-body py-0 py-md-2">
              <h5 className="bold mb-0 text-base text-pink-500">
                Nạp bằng QR Code
              </h5>
              <div className="d-flex justify-content-center mb-2 mt-1">
                {info == null ? (
                  <div
                    className="text-center spinner-border"
                    role="status"
                  ></div>
                ) : (
                  <QRCode
                    includeMargin="true"
                    fgColor="#FFFFFF"
                    bgColor="#ff69b4"
                    size={256}
                    renderAs="svg"
                    style={qrCodeStyle}
                    value="2|99|0928889798|||0|0|1000|Cảm ơn bạn đã ủng hộ Hust Media! 💼😊|transfer_myqr"
                  />
                )}

              </div>
              {isDivVisible && (
                <>
                  <p className="mb-0 text-sm" onClick={handleToggle}>Tắt quảng cáo </p>
                  <div className="mb-4 bg-pink-300" > <Bannerprofile /> </div>   </>)}

            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Momoidcode;
